import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VSkeletonLoader,
    {
      staticClass: "last-triggered-info",
      style: { "min-width": `${_vm.width}px` },
      attrs: { width: _vm.width, type: "text", loading: _vm.loading },
    },
    [
      _vm.noRecordedRuns
        ? _c("div", { staticClass: "last-run-text last-run-text--empty" }, [
            _c("div", { staticClass: "last-run-time" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("gridView.engineNoRecordedRuns")) +
                  "\n    "
              ),
            ]),
          ])
        : _vm.simplified
        ? _c(
            "div",
            { staticClass: "last-run-text last-run-text--simplified" },
            [
              _c("div", { staticClass: "last-run-time" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.formatDate(_vm.lastTriggeredInfo.date)) +
                    "\n    "
                ),
              ]),
            ]
          )
        : _c(
            "div",
            { staticClass: "last-run-text" },
            [
              _c("div", { staticClass: "last-run-time" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t(_vm.translationTimeKey)) +
                    "\n      "
                ),
                _c("strong", [
                  _vm._v(_vm._s(_vm.formatDate(_vm.lastTriggeredInfo.date))),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "last-run-user" }, [
                _vm._v(
                  "\n      " + _vm._s(_vm.$t("gridView.engineLastRunBy")) + " "
                ),
                _c("strong", [_vm._v(_vm._s(_vm.lastTriggeredInfo.username))]),
              ]),
              _vm._v(" "),
              _vm.usedSimulatedCompetitorPrices
                ? _c("div", { staticClass: "last-run-sim" }, [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.$t("gridView.engineLastRunWith")) +
                        "\n      "
                    ),
                    _c("strong", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "gridView.engineLastRunSimulatedCompetitorPrices"
                          )
                        )
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.skippedAlerts
                ? _c("div", { staticClass: "last-run-sim" }, [
                    _c("strong", [
                      _vm._v(
                        _vm._s(_vm.$t("gridView.engineLastRunWithoutAlerts"))
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.hasMarginSteeringDeltaInfo
                ? _c("div", { staticClass: "last-run-delta" }, [
                    _vm._v(
                      "\n      " +
                        _vm._s(
                          _vm.$t("gridView.marginInitialisationLastRunWith")
                        ) +
                        "\n      "
                    ),
                    _vm.retainedMarginSteeringDelta
                      ? _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("gridView.marginSteeringDeltaRetained")
                            )
                          ),
                        ])
                      : _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("gridView.marginSteeringDeltaNotRetained")
                            )
                          ),
                        ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._t("extrainfo"),
            ],
            2
          ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }